import React, { useState, useEffect } from 'react';
import drawer from '../../../Assets/Announcement//images/arrow-up.svg';
import { useHistory } from "react-router-dom";
import downarrow from '../../../Assets/Announcement/Assets-Desktop/arrow_down.svg';
import '../../../css/Vessel/Vessel.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import DropDownTable from '../../Shared/DropDownTable';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL, trackingBaseURL } from '../../../Services/config/apiGateway';
import { ALLPORTTERMINALS_ENDPOIN } from '../../../Services/config/apiEndPoints';
import { VESSEL_NAME_ENDPOINT } from '../../../Services/config/apiEndPoints';
import Message from '../../../Data/Shared/Message.json';
import { PortAlphaSorting } from '../../../Services/utils/AlphaSorting';


const Vessel = props => {
    let history = useHistory();
    const [terminalDropdown, setTerminalDropdown] = useState(false);
    const container = React.createRef();
    const [vesselDropdown, setVesselDropdown] = useState(false);
    const [terminal, setTerminal] = useState('');
    const [vessel, setVessel] = useState('');
    const [errors, setErrors] = useState({});
    const [portData, setPortData] = useState([]);
    const [portCode, setPortCode] = useState('');
    const [vesselData, setVesselData] = useState([]);
    const [vesselRefNbr, setVesselRefNbr] = useState('');
    const [vesselSelectAvailable, setVesselSelectAvailable] = useState(false);

    useEffect(() => {
        if (history.action === "REPLACE" || history.action === 'POP') {
            setPortCode(history.location.state?.facilityCode);
            setVesselRefNbr(history.location.state?.vesselRefNbr);
            setTerminal(history.location.state?.terminal);
            setVessel(history.location.state?.vesselName);
        }

        let unmounted = false;
        if (terminal?.length === 0) {
            setVesselDropdown(false);
        }
        ApiCall(
            'GET',
            utilityBaseURL + ALLPORTTERMINALS_ENDPOIN,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',

            },
        ).then((data) => {
            if (!unmounted) {
                if (data.flag != -1) {
                    if (data.flag == 500) {
                        console.log('I am 500!');
                    } else {
                        console.log('I am 200!');
                        data = PortAlphaSorting(data);
                        setPortData(data);
                    }
                } else {
                    console.log('Something went wrong!');
                }
            }
        });
        return () => { unmounted = true };
    }, []);

    const handleClickOutside = event => {
        if (container.current && !container.current.contains(event.target)) {
            setTerminalDropdown(false);
            setVesselDropdown(false);
        }
    };
    document.addEventListener("mousedown", handleClickOutside);

    const toggleTerminalDropdown = () => {
        setTerminalDropdown(!terminalDropdown);
    };

    const toggleVesselDropdown = () => {
        if (terminal?.length === 0 || vesselSelectAvailable === false) {
            setVesselDropdown(false);
        }
        else {
            setVesselDropdown(!vesselDropdown);
        }
    };

    const validate = () => {
        let error = {};
        let isValid = true;
        if (!terminal) {
            isValid = false;
            error["terminal"] = Message.validation.required;
        }
        if (!vessel) {
            isValid = false;
            error["vessel"] = Message.validation.required;
        }
        setErrors(error);
        return isValid;
    }

    const submitVessel = () => {
        if (validate()) {
            history.push({
                pathname: `/vesselDetails/${portCode}/${vesselRefNbr}`,
                search: `terminal=${terminal}&vessel=${vessel}`,
            });
        }
    };

    const changeTerminal = (event) => {
        let portCodeNum = '';
        portData?.find((name) => {
            if (name?.portId === portData[event]?.portId) {
                setPortCode(name?.portCode);
                portCodeNum = name?.portCode;
                return name
            }
        })
        setTerminal(portData[event]?.portName?.split(':')[0]);
        setVessel("");

        if (portData[event]?.portName?.length > 0) {
            ApiCall(
                'GET',
                trackingBaseURL + VESSEL_NAME_ENDPOINT + `?facilityCode=${portCodeNum}`,
                {},
                {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',

                },
            ).then((data) => {
                if (data.flag != -1) {
                    if (data.flag == 500) {
                        setVesselSelectAvailable(false);
                    } else {
                        console.log('I am 200!');
                        setVesselSelectAvailable(true);
                        setVesselData(data);
                    }
                }
            });
        }
        setTerminalDropdown(false);
    }

    const changeVessel = (index) => {
        vesselData?.find((name) => {
            if (name?.vesselName === vesselData[index]?.vesselName) {
                setVesselRefNbr(name?.vesselRefNbr);
                return name
            }
        })
        setVessel(`${vesselData[index]?.vesselName} - ${vesselData[index]?.vesselRefNbr}`);
        setVesselDropdown(false);
    }

    const eye = terminalDropdown ? <img src={drawer} /> : <img src={downarrow} />
    const eye2 = vesselDropdown ? <img src={drawer} /> : <img src={downarrow} />

    return (
        <div>
            <div class="outer11" >
                <MetaDecorator title={TitleDescription.vesselPageTitle} description={TitleDescription.vesselPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="midDiv" id="vsbox1" >
                    <div class="vupNav">
                        <div class="vs01">
                            <small class="" id="vcccc">Vessel Status </small>
                        </div>
                    </div>
                    <hr class="hr1" />
                    <div class="vesselrow2">

                        <div></div>
                        <div class="vs02">
                            <div class="vs03" >
                                <small class="p-1" id="" class="vs04" >Terminal </small>
                            </div>
                            <div class="vs05" >
                                <div className="pass-wrapper" id="vs07" > 
                                    <input readOnly class="form-control form-control-sm outline4" id="vs06" placeholder="Select Terminal" type="text" value={terminal} ></input>
                                    <i id="vesselinput_img" onClick={toggleTerminalDropdown}>{eye}</i>
                                </div>
                                <div className="vesselerror">{errors.terminal}</div>
                                {terminalDropdown && (
                                    <div class="vessel08" >
                                        <div class="vsdropdowncard" ref={container}>
                                            {(portData?.map((name, index) => {
                                                return (
                                                    name.portCode != "NA" &&
                                                    <DropDownTable key={index} onClick={() => changeTerminal(index)} >
                                                        <small id="tt2" >  {name?.portName?.split(':')[0]} </small>
                                                    </DropDownTable>
                                                );
                                            }))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div class="vs10" >
                            <div class="vs03" >
                                <small class="p-1" id="vs044" >Vessel </small> 
                            </div>
                            <div class="vs05">
                                <div className="pass-wrapper" id="vs07">
                                    <input readOnly class="form-control form-control-sm outline4" id="input06" placeholder="Select Vessel" type="text" value={vessel} ></input>
                                    <i id="vesselinput_img" onClick={toggleVesselDropdown}>{eye2}</i>
                                </div>
                                <div className="vesselerror">{errors.vessel}</div>
                                {vesselDropdown && vesselSelectAvailable && (
                                    <div class="vessel08" >
                                        <div class="vsdropdowncard" ref={container}>
                                            {(vesselData?.map((name, index) => {
                                                return (
                                                    <DropDownTable key={index} onClick={() => changeVessel(index)} >
                                                        <small id="tt2" >{name?.vesselName} - {name?.vesselRefNbr} </small>
                                                    </DropDownTable>
                                                );
                                            }))}

                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div class="vbutt1">
                        <Button class="butt" onClick={submitVessel}
                        >
                            <small class="bt01"> Continue</small>
                        </Button>
                    </div>
                </div>
                <div class="footer22">
                    <Footer2 />
                </div>
            </div>
            <div class="footer11">
                <Footer />
            </div>
        </div>
    );
}


export default Vessel;